const shouldUseMockData = () => {
  return process.env.REACT_APP_USE_MOCK_API === 'true' || process.env.NODE_ENV === 'production';
};

export default shouldUseMockData;
